import React from 'react';
import PropTypes from 'prop-types';

import Table from '../Table';
import TableHead from '../TableHead';
import TableBody from '../TableBody';
import TableRow from '../TableRow';
import TableCell from '../TableCell';

// const StudyListExpandedRow = ({ seriesTableColumns, seriesTableDataSource, children }) => {
//   return (
//     <div className="w-full bg-black py-4 pl-12 pr-2">
//       <div className="block">{children}</div>
//       <div className="mt-4">
//         <Table>
//           <TableHead>
//             <TableRow>
//               {Object.keys(seriesTableColumns).map(columnKey => {
//                 return <TableCell key={columnKey}>{seriesTableColumns[columnKey]}</TableCell>;
//               })}
//             </TableRow>
//           </TableHead>
//
//           <TableBody>
//             {seriesTableDataSource.map((row, i) => (
//               <TableRow key={i}>
//                 {Object.keys(row).map(cellKey => {
//                   const content = row[cellKey];
//                   return (
//                     <TableCell
//                       key={cellKey}
//                       className="truncate"
//                     >
//                       {content}
//                     </TableCell>
//                   );
//                 })}
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </div>
//     </div>
//   );
// };
const StudyListExpandedRow = ({ seriesTableColumns, seriesTableDataSource, children }) => {
  return (
    <div className="grid py-2 pl-4 pr-2">{children}</div>
    // <div className="w-full bg-black py-4 pl-4 pr-2">
    //   {/* Contenido superior */}

    //   {/* Vista mobile: tipo tarjeta */}
    //   <div className="mt-4 space-y-4 md:hidden">
    //     {seriesTableDataSource.map((row, index) => (
    //       <div
    //         key={index}
    //         className="rounded-lg border border-gray-700 bg-gray-900 p-4 shadow"
    //       >
    //         {Object.keys(row).map((key, i) => (
    //           <div
    //             key={i}
    //             className="mb-1 text-sm text-gray-300"
    //           >
    //             <span className="font-semibold text-gray-400">
    //               {seriesTableColumns[key] || key}:
    //             </span>{' '}
    //             {row[key]}
    //           </div>
    //         ))}
    //       </div>
    //     ))}
    //   </div>

    //   {/* Vista desktop: tabla */}
    //   <div className="mt-4 hidden md:block">
    //     <Table>
    //       <TableHead>
    //         <TableRow>
    //           {Object.keys(seriesTableColumns).map(columnKey => (
    //             <TableCell key={columnKey}>{seriesTableColumns[columnKey]}</TableCell>
    //           ))}
    //         </TableRow>
    //       </TableHead>

    //       <TableBody>
    //         {seriesTableDataSource.map((row, i) => (
    //           <TableRow key={i}>
    //             {Object.keys(row).map(cellKey => (
    //               <TableCell
    //                 key={cellKey}
    //                 className="truncate"
    //               >
    //                 {row[cellKey]}
    //               </TableCell>
    //             ))}
    //           </TableRow>
    //         ))}
    //       </TableBody>
    //     </Table>
    //   </div>
    // </div>
  );
};

StudyListExpandedRow.propTypes = {
  seriesTableDataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  seriesTableColumns: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default StudyListExpandedRow;
